import { Alert, Form, Modal, Select } from "antd";
import { useFetchCreditorSummariesQuery } from "features/creditors/agencyPortal/creditorsAPI";

export default function PaymentAllocationCreditorModal({ open, onOk, onCancel }) {
  const [form] = Form.useForm();
  const { data: creditors } = useFetchCreditorSummariesQuery();
  const onSubmit = async () => {
    const data = await form.validateFields();
    onOk(data);
  };

  return (
    <Modal
      maskClosable={false}
      title="Update Allocated Creditor"
      open={open}
      onOk={onSubmit}
      onCancel={onCancel}
    >
      <Alert
        type="warning"
        showIcon
        message="Changing the allocated creditor may affect past and future invoices for the selected payment allocations."
        style={{ marginBottom: 16 }}
      />
      <Form
        form={form}
        layout="vertical"
        validateMessages={{ required: "This is a required field" }}
        initialValues={{ creditorId: null }}
      >
        <Form.Item name="creditorId" rules={[{ required: true }]}>
          <Select
            data-testid="creditor-select"
            showSearch
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            popupMatchSelectWidth={false}
            placeholder="Select Creditor"
            allowClear
            options={(creditors ?? []).map((d) => ({
              label: d.code ? `${d.name} (${d.code})` : d.name,
              value: d.id,
            }))}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
